// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"kQ4Q5ge1xL8phhL2AzJU"};